import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth'; // <--- NEW IMPORT

const firebaseConfig = {
apiKey: "AIzaSyB7vU21n7CIN2nLWTyKWAgaA7Xrzpc1JTI",
  authDomain: "ev-upgrades.firebaseapp.com",
  projectId: "ev-upgrades",
  storageBucket: "ev-upgrades.firebasestorage.app",
  messagingSenderId: "369258409002",
  appId: "1:369258409002:web:16112e6ab31be7e9fb6753",
  measurementId: "G-DYGNXKW29Q"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app); // <--- EXPORT AUTH
